import React, { useEffect, useState } from 'react';
import { Cookie, X, Check } from '@phosphor-icons/react';

const CONSENT_KEY = 'oscop_cookie_consent'; // 'granted' | 'denied' | (null → non répondu)

export function getCookieConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function isTrackingAllowed() {
  return getCookieConsent() === 'granted';
}

export default function CookieConsent() {
  const [consent, setConsent] = useState(() => getCookieConsent());
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Petit délai pour l'animation d'entrée
    const t = setTimeout(() => setMounted(true), 400);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(CONSENT_KEY, value); } catch {}
    setConsent(value);
    // Notifier les composants listeners
    window.dispatchEvent(new CustomEvent('oscop:cookie-consent', { detail: { value } }));
  };

  if (consent) return null; // déjà répondu

  return (
    <div
      className={`fixed bottom-4 left-4 right-4 md:left-6 md:bottom-6 md:right-auto md:max-w-md z-[70] transition-all duration-500 ${
        mounted ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
      role="dialog"
      aria-live="polite"
      aria-label="Consentement aux cookies"
      data-testid="cookie-consent-banner"
    >
      <div className="rounded-2xl bg-white/95 backdrop-blur-xl border border-[#E8E6E1] shadow-2xl overflow-hidden">
        <div className="flex gap-1 h-1">
          <span className="flex-1" style={{ background: '#00AEEF' }} />
          <span className="flex-1" style={{ background: '#80C51F' }} />
          <span className="flex-1" style={{ background: '#EA3C3A' }} />
          <span className="flex-1" style={{ background: '#FF8E00' }} />
          <span className="flex-1" style={{ background: '#D5007D' }} />
        </div>
        <div className="p-5">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-[#F5F4EF] border border-[#E8E6E1] flex items-center justify-center flex-shrink-0">
              <Cookie size={20} weight="duotone" className="text-[#FF8E00]" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-[#1A2421]" style={{ fontFamily: 'Manrope' }}>
                Vos statistiques de visite, anonymes
              </p>
              <p className="mt-1.5 text-xs text-[#5E6D66] leading-relaxed">
                Nous mesurons le nombre de visites et les clics de partage pour améliorer la page — sans cookie tiers, sans profilage, sans donnée personnelle. Vous pouvez refuser sans impact sur la navigation.
              </p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => decide('granted')}
              className="inline-flex items-center gap-1.5 bg-[#2D5A4C] hover:bg-[#1E4136] text-white text-xs font-semibold px-4 py-2 rounded-full transition-colors shadow"
              data-testid="cookie-accept"
            >
              <Check size={14} weight="bold" /> J'accepte
            </button>
            <button
              onClick={() => decide('denied')}
              className="inline-flex items-center gap-1.5 bg-white hover:bg-[#F5F4EF] text-[#1A2421] text-xs font-semibold px-4 py-2 rounded-full border border-[#E8E6E1] transition-colors"
              data-testid="cookie-deny"
            >
              <X size={14} weight="bold" /> Je refuse
            </button>
            <a
              href="/confidentialite"
              className="inline-flex items-center text-[11px] font-semibold text-[#5E6D66] hover:text-[#2D5A4C] underline underline-offset-4 ml-auto self-center"
              data-testid="cookie-privacy-link"
            >
              En savoir plus
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
